import { gql } from '@apollo/client';

export const SET_USER_EXTRA = gql`
  mutation SetUserExtra($userId: Int!, $userExtra: UserExtraInput!) {
    setUserExtra(user_id: $userId, data: $userExtra) {
      user_id
    }
  }
`;
